/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import {
  ISiteSelectionProps
} from '../../../stores/GatewayManager/IGatewayRegistrationInterfaces';
import { default as React, useState } from 'react';
import SiteSelection from './SiteSelection';
import {
  ICondition,
  loadOnConditionsSatisfied
} from '../../common/ConditionalLoader';
import { DIYErrorPage, INavigationButton } from '../../common/DIYErrorPage';

/**
 * Properties for Launch DIY gateway management
 */
export interface ILaunchDIYGatewayManagementProps extends ISiteSelectionProps {
  conditions?: ICondition[]
}

/**
 * This functional component launches the site selection page subject to following conditions
 * 1. The feature flag `` is enabled
 * 2. The parameters passed to the application are good enough to perform gateway registration
 *
 * In case the feature flag is not enabled, it will direct to error page
 * If the URL parameters are not sufficient it will direc to error page
 * @Todo Eventually the idea is to launch an interactive form to fill in the missing details
 */
export const LaunchDIYGatewayManagement = (launchProps: ILaunchDIYGatewayManagementProps) => {

  const [conditions] = useState(launchProps.conditions || [] as ICondition[])

  const LoadSitesOnConditionsSatisfied = loadOnConditionsSatisfied(SiteSelection, DIYErrorPage);
  let backButton: INavigationButton = {
    content: 'Back',
    onClick: () => {
    }
  };

  return (conditions.length > 0) ? <LoadSitesOnConditionsSatisfied
    title={'Launching application'}
    {...launchProps}
    message={'If this repeats, contact support or retry after sometime.'}
    showSupportLink={true}
    errorTitle={'Service not available...'}
    additionalNavButtons={[backButton]}
    conditions={conditions}
  ></LoadSitesOnConditionsSatisfied> : <></>;
};

